import Vue from 'vue';

import draggable from 'vuedraggable'

import TextInput from '@/components/bs/FormElementTextInput'
import PhoneInput from '@/components/bs/FormElementPhoneInput'
import LongTextInput from '@/components/bs/FormElementLongTextInput'
import NumberInput from '@/components/bs/FormElementNumberInput'
import EmailInput from '@/components/bs/FormElementEmailInput'
import SelectList from '@/components/bs/FormElementSelectList'
import RadioButton from '@/components/bs/FormElementRadioButton'
import Checkbox from '@/components/bs/FormElementCheckbox'
import Flag from '@/components/bs/FormElementFlag'
import DatePicker from '@/components/bs/FormElementDatePicker'
import TimePicker from '@/components/bs/FormElementTimePicker'
import Rating from '@/components/bs/FormElementRating'
import Button from '@/components/bs/FormElementButton'
import ElSwitch from '@/components/bs/FormElementSwitch'
import Carousel from '@/components/bs/FormElementCarousel'
import Upload from '@/components/bs/FormElementUpload'
import HtmlComponent from '@/components/bs/FormElementHtml'
import NoticeComponent from '@/components/bs/FormElementNotice'
import ModalComponent from '@/components/bs/FormElementModal'
import Elements from '@/components/bs/Elements'
import TemplatedSections from '@/components/bs/TemplatedSections'
import TemplatedFields from '@/components/bs/TemplatedFields'
import ConditioningFields from '@/components/bs/ConditioningFields'
import Properties from '@/components/bs/properties/Properties'

// import vm from '@/main'

export const FormBuilder = new Vue({
  components: {
    Elements,
    TemplatedSections,
    TemplatedFields,
    ConditioningFields,
    Properties,
    draggable,
    TextInput,
    PhoneInput,
    LongTextInput,
    NumberInput,
    EmailInput,
    SelectList,
    RadioButton,
    Checkbox,
    Flag,
    TimePicker,
    DatePicker,
    Rating,
    Button,
    Carousel,
    Upload,
    ElSwitch,
    HtmlComponent,
    NoticeComponent,
    ModalComponent
  },
  data() {
    return {
      fields: [],
      sortElementOptions: {
        group: {
          name: 'formbuilder',
          pull: false,
          put: true
        },
        sort: true
      },

      dropElementOptions: {
        group: {
          name: 'formbuilder',
          pull: 'clone',
          put: false
        },
        sort: false,
        filter: ".is-disabled"
      }
    }
  },

  methods: {
    deleteElement(index, form, vm) {
      vm.$store.activeField = [];
      vm.$store.activeTabForFields = "elements";
      this.$delete(form, index);
    },

    cloneElement(index, field, form) {
      var cloned = window._.cloneDeep(field) // clone deep lodash
      form.splice(index, 0, cloned)
    },

    editElementProperties(field, activeSectionTagName = null, vm) {
      vm.$store.activeSectionTagName = activeSectionTagName ? activeSectionTagName : null;
      vm.$store.activeField = field;
      vm.$store.activeSection = [];
      vm.$store.editingSection = false;
      vm.$store.activeTabForFields = "properties";
    },

    editSectionProperties(activeSection, vm) {
      vm.$store.activeSectionTagName = activeSection.tagName;
      vm.$store.activeField = [];
      vm.$store.activeSection = activeSection;
      vm.$store.editingSection = true;
      vm.$store.activeTabForFields = "properties";
    }
  }
});
